const ABORT_ERROR_NAME = 'AbortError';

export function isAbortError(error: unknown) {
  return error instanceof DOMException && error.name === ABORT_ERROR_NAME;
}

export function createAbortError(message: string) {
  return new DOMException(message, ABORT_ERROR_NAME);
}
